/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.inbox.InboxRecipientKind
*/
export var InboxRecipientKind;
(function (InboxRecipientKind) {
    InboxRecipientKind["USER"] = "USER";
    InboxRecipientKind["TEAM"] = "TEAM";
})(InboxRecipientKind || (InboxRecipientKind = {}));
//# sourceMappingURL=InboxRecipientKind.js.map